import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic-map-search",
  "use": "icon-ic-map-search-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-ic-map-search\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.667 2.667a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-3.771.228a5.333 5.333 0 0 1 7.984 7.042l3.592 3.592a.667.667 0 0 1-.943.942L9.937 10.88a5.334 5.334 0 0 1-7.041-7.985Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol